export default "__VITE_ASSET__DGfdgg8O__";